<template>
  <el-card>
    <div>
      <el-row>
        <el-input style="width:150px" v-model="title" placeholder="请输入名称"></el-input>
        <el-select @change="selectVideo" v-model="type">
          <el-option label="单视频" value="0">单视频</el-option>
          <el-option label="视频集" value="1">视频集</el-option>
        </el-select>
        <el-button @click="searchthis()" type="primary">搜索</el-button>
      </el-row>
      <div class="newvideo">
        <ul class="clearfloat">
          <li v-for="(item,index) in offlinelist" :key="item.id">
            <a @click="govideoDetail(item.id)">
              <el-image v-if="videoType==1" :src="item.imgUrl" fit="cover"></el-image>
              <el-image v-if="videoType==0" :src="item.fileLocation" fit="cover"></el-image>
            </a>
            <div class="txt-video">
              <h4
                v-if="videoType==0"
                :title="item.fileName"
                class="tac"
                style="margin:0 auto;"
              >{{item.fileName}}</h4>
              <h4
                v-if="videoType==1"
                :title="item.title"
                class="tac"
                style="margin:0 auto;"
              >{{item.title}}</h4>
              <div style="padding:15px;">
                <div>
                  <span>时间：</span>
                  <span>{{item.offlineTime}}</span>
                </div>
                <div class="reason">
                  <p>
                    <span>理由：</span>
                    <span>{{item.reason}}</span>
                  </p>
                </div>
              </div>
              <div class="tac">
                <el-button
                  style="margin-left: 20px"
                  type="primary"
                  size="mini"
                  @click="upline(item.id)"
                >恢复上线</el-button>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="limit"
        :current-page="page"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <div style="height: 50px"></div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      total: 0, // 分页总数
      limit: 20,
      offlinelist: {},
      title: "",
      type: "0",
      videoType: ""
    };
  },
  methods: {
    selectVideo: function() {
      console.log(this.type);
    },
    getlist: async function() {
      var title1 = this.title;
      var res = await this.$http.get(
        `/v1/videoInfo/offLineVideoList?title=${title1}&page=${this.page}&type=${this.type}`
      );
      var { code, data, message, total } = res.data;
      if (code == 0) {
        this.total = total;
        this.offlinelist = data.data;
        this.videoType = data.type;
      } else {
        this.$message.error(message);
      }
    },
    upline: async function(item) {
      var id = item;
      var res = await this.$http.post(
        `/v1/videoInfo/offLineVideoInfo?id=${id}&type=${this.videoType}`
      );
      var { data, message, code } = res.data;
      if (code == 0) {
        this.$message.success("恢复上线成功");
        this.getlist();
      } else {
        this.$message.error(message);
      }
    },
    handleCurrentChange: function(val) {
      this.page = val;
      this.getlist();
    },
    searchthis: function() {
      this.page = 1;
      this.getlist();
    },
    govideoDetail: function(val) {
      this.$store.state.offlineType = this.videoType;
      this.$router.push(`/videodetail2?id=${val}&status=${this.videoType}`);
    }
  },
  mounted() {
    // this.getlist();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path == "/videodetail2") {
        vm.type = vm.$store.state.offlineType;
        vm.getlist();
      } else {
        vm.getlist();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.el-container {
  position: relative;
  margin: 0 auto;
}
.el-image {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    // display: block;
    vertical-align: middle;
  }
}
// @media screen and (min-width: 1200px) {
.v_image {
  position: static;
  z-index: 1;
}

// 宣传位图片列表
.newvideo {
  margin-top: 30px;
}
.newvideo li {
  width: 23.5%;
  float: left;
  margin-right: 2%;
  margin-bottom: 30px;
  height: 350px;
  border: 1px solid #f5f5f5;
  &:nth-child(4n) {
    margin-right: 0;
  }
  .el-image {
    height: 150px;
  }
  div span {
    font-size: 14px;
  }
  .txt-video {
    height: 200px;
    padding: 20px 10px;
    h4 {
      text-align: center;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .reason {
      height: 60px;
      p {
        height: 100%;
        overflow: hidden;
        &:hover {
          overflow-y: auto;
        }
      }
    }
  }
}
// }
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/ofLineVideo-mg/oflineVideoList-mg.vue